exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".badge__3ySnA{padding:.4em;font-size:.6em;line-height:.76em;z-index:100;color:#000;font-weight:700;display:block;border-radius:1em;background:orange;position:absolute;top:.5em;right:1em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/simple-badge/C:/dev/globalTopBar/src/components/common/simple-badge/C:/dev/globalTopBar/src/components/common/simple-badge/styles.scss"],"names":[],"mappings":"AAAA,cACE,aACA,eACA,kBACA,YACA,WACA,gBACA,cACA,kBACA,kBACA,kBACA,SACA,SAAU,CACX","file":"styles.scss","sourcesContent":[".badge {\n  padding: .4em;\n  font-size: .6em;\n  line-height: .76em;\n  z-index: 100;\n  color: black;\n  font-weight: bold;\n  display: block;\n  border-radius: 1em;\n  background: #ffa500;\n  position: absolute;\n  top: .5em;\n  right: 1em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"badge": "badge__3ySnA"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/common/simple-badge/styles.scss
// module id = YMyA
// module chunks = 0